import { Seo } from "@/components/Seo";
import { Reveal, HoldingsWordmark, SectionTitle } from "@/components/primitives";

const S = ({ n, title, children }) => (
  <Reveal>
    <div className="mb-8">
      <h3 className="font-display uppercase tracking-wide2 text-base md:text-lg gold-text">{n}. {title}</h3>
      <div className="mt-3 space-y-3 text-[var(--bone)]/85 leading-relaxed">{children}</div>
    </div>
  </Reveal>
);

export default function Privacy() {
  return (
    <div className="glow-black min-h-screen">
      <Seo title="Privacy Policy" description="Privacy Policy for Jennae Michelle Holdings LLC." />
      <section className="pt-28 md:pt-36 pb-8 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal className="text-center mb-8">
            <p className="font-display uppercase tracking-luxe text-xs text-[var(--muted)] mb-8">Privacy Policy</p>
            <HoldingsWordmark size="md" />
          </Reveal>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div className="max-w-3xl mx-auto border border-[rgba(180,139,63,0.18)] px-6 md:px-10 py-10">
          <Reveal>
            <p className="text-[var(--bone)]/85 mb-8">
              <strong className="font-display uppercase tracking-wide2 text-sm gold-text">Privacy Policy</strong><br />
              Effective Date: 3/10/2026<br />Company Name: Jennae Michelle Holdings LLC
            </p>
          </Reveal>

          <S n="1" title="Information We Collect">
            <p>We may collect the following information when you interact with our website or services:</p>
            <ul className="list-disc pl-6 space-y-1"><li>Name</li><li>Phone number</li><li>Email address (if provided)</li></ul>
            <p>Information you voluntarily submit (e.g., property details, inquiries).</p>
            <p>Messaging data related to your communication with us.</p>
          </S>
          <S n="2" title="How We Use Your Information">
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Respond to inquiries and provide requested services</li>
              <li>Communicate with you via SMS or other channels</li>
              <li>Provide customer support</li>
              <li>Improve our services and user experience</li>
            </ul>
          </S>
          <S n="3" title="SMS Communications">
            <p>By providing your phone number or initiating contact with us, you consent to receive SMS messages related to your inquiry.</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Message frequency varies based on interaction</li>
              <li>Message and data rates may apply</li>
              <li>You can opt out at any time by replying STOP</li>
              <li>You can request help by replying HELP</li>
            </ul>
          </S>
          <S n="4" title="Data Sharing">
            <p>We do not sell, rent, or share your personal information with third parties for marketing purposes.</p>
            <p>We may share data only with service providers necessary to operate our business (e.g., messaging platforms), and only to the extent required.</p>
          </S>
          <S n="5" title="Data Security">
            <p>We implement reasonable safeguards to protect your information. However, no method of transmission over the internet is 100% secure.</p>
          </S>
          <S n="6" title="Your Rights">
            <p>You may:</p>
            <ul className="list-disc pl-6 space-y-1"><li>Request access to your data</li><li>Request deletion of your data</li><li>Opt out of communications at any time</li></ul>
          </S>
          <S n="7" title="Changes to This Policy">
            <p>We may update this Privacy Policy from time to time. Updates will be posted on this page.</p>
          </S>
          <S n="8" title="Contact Information">
            <p>If you have questions, contact us at:</p>
            <p>Email: <a href="mailto:admin@jennaemichelle.com" className="gold-text link-underline">admin@jennaemichelle.com</a></p>
          </S>
        </div>
      </section>
    </div>
  );
}
